import {
  REFERRALS_FETCH_REQUESTED,
  REFERRALS_FETCHED,
  REFERRAL_FETCHED,
} from 'utils/constants'
import { reduce } from 'lodash';

export default (state = {}, action) => {
  switch (action.type) {
    case REFERRAL_FETCHED: {
      const { referrals } = state;
      const { referral } = action.data;
      return {
        ...state,
        fetching: false,
        referrals: { ...referrals, [referral.id]: referral }
      };
    }
    case REFERRALS_FETCH_REQUESTED:
      return { ...state, fetching: true };
    case REFERRALS_FETCHED:
      const referrals = reduce(action.data.referrals, (obj, referral) => {
        obj[referral.id] = referral
        return obj
      }, {});
      return { ...state, fetching: false, referrals };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/referrals.js